__turbopack_context__.v({
  "bar": "mobile-action-bar-module__2dcd1q__bar",
  "tab": "mobile-action-bar-module__2dcd1q__tab",
});
